// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zrnnKgqd8zVcwiV3Ohrh {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.V_p_k342ekky0oYg_AxE {
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--dst-text);
}

.cEsCc6UFyhYVH1RRPySP {
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 6px;
  font-size: 1em;
  border: 1px solid transparent;
}

.cEsCc6UFyhYVH1RRPySP.cdYHpdIYqZcEUSkX_viA {
  background: var(--dst-error-bg);
  color: var(--dst-error-text);
  border-color: var(--dst-error-border);
}

.cEsCc6UFyhYVH1RRPySP.DJHreniN47YWIu3ySOvF {
  background: var(--dst-success-bg);
  color: var(--dst-success-text);
  border-color: var(--dst-success-border);
}

.TUgL9kYas9uFiVR_c4aY {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.hvZVl0xvldSltremtLE2 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 14px;
}

.I3WnSXs8T_B84eevGhBM {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

._9Wj9uBzlLRBxKFIsuQdA {
  grid-column: span 2;
  min-width: 320px;
}

.iM4q_MtVyEuCTjhXzOAi {
  font-size: 0.75em;
  color: var(--dst-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.B3V4tzkUVM5zdHYWqqv7 {
  font-weight: 600;
  font-size: 0.9em;
  color: var(--dst-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.JtA8ditqklrcVJRzwiOt {
  color: var(--dst-muted);
  font-weight: 400;
}

.KlgQNmlH6zpNi0FMmk88 {
  width: 100%;
  box-sizing: border-box;
  min-height: 44px;
  padding: 8px 10px;
  border: 1px solid var(--dst-input-border);
  border-radius: 6px;
  font-size: 1em;
  font-family: inherit;
  color: var(--dst-text);
  background: var(--dst-input-bg);
  transition: border-color 0.14s, box-shadow 0.14s;
}

.KlgQNmlH6zpNi0FMmk88:focus {
  outline: none;
  border-color: var(--dst-primary);
  box-shadow: 0 0 0 3px rgba(32, 94, 200, 0.15);
}

.KlgQNmlH6zpNi0FMmk88:disabled {
  background: var(--dst-input-disabled-bg);
  cursor: not-allowed;
  opacity: 0.7;
}

.a8Wn6KbrBaFrF6dFNCbA {
  color: var(--dst-muted);
  font-size: 0.95em;
  padding: 8px 0;
}

.ihjTVP2TpeFXtTc0qi_T {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bdfelXso0RVveyjTtjKf {
  font-weight: 600;
  font-size: 0.95em;
  color: var(--dst-text);
}

.ZdA9vPCjHgN321OY69PN {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
}

.HJ0iYyxjsuXbkZgMhf8T {
  min-height: 36px;
  padding: 7px 14px;
  border: 1px solid var(--dst-input-border);
  border-radius: 6px;
  background: var(--dst-input-bg);
  color: var(--dst-text);
  font-family: inherit;
  font-size: 0.9em;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.13s, background 0.13s, color 0.13s;
}

.HJ0iYyxjsuXbkZgMhf8T:hover:not(:disabled) {
  border-color: var(--dst-primary);
  color: var(--dst-primary);
}

.yMLh0cUgL0lmJjspp1GM {
  border-color: var(--dst-primary);
  background: var(--dst-primary);
  color: white;
}

.yMLh0cUgL0lmJjspp1GM:hover:not(:disabled) {
  color: white;
}

.HJ0iYyxjsuXbkZgMhf8T:focus-visible {
  outline: 3px solid rgba(32, 94, 200, 0.35);
  outline-offset: 2px;
}

.HJ0iYyxjsuXbkZgMhf8T:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.dtW4oELHD4VZ9JObjRq_,
.mN_GiZS1INZxWaUbIifg,
.kqUqvWv8oL_OJOB8GE7W {
  min-height: 44px;
  padding: 8px 10px;
  border: 1px solid var(--dst-input-border);
  border-radius: 6px;
  font-size: 1em;
  font-family: inherit;
  color: var(--dst-text);
  background: var(--dst-input-bg);
  transition: border-color 0.14s, box-shadow 0.14s;
}

.dtW4oELHD4VZ9JObjRq_:focus,
.mN_GiZS1INZxWaUbIifg:focus,
.kqUqvWv8oL_OJOB8GE7W:focus {
  outline: none;
  border-color: var(--dst-primary);
  box-shadow: 0 0 0 3px rgba(32, 94, 200, 0.15);
}

.dtW4oELHD4VZ9JObjRq_:disabled,
.mN_GiZS1INZxWaUbIifg:disabled,
.kqUqvWv8oL_OJOB8GE7W:disabled {
  background: var(--dst-input-disabled-bg);
  cursor: not-allowed;
  opacity: 0.7;
}

.kqUqvWv8oL_OJOB8GE7W {
  resize: vertical;
  font-family: inherit;
}

.ZNmiFA8U7s7XzmBlxvUI {
  min-height: 44px;
  padding: 10px 20px;
  font-size: 1em;
  font-weight: 600;
  background: var(--dst-primary);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.13s;
  align-self: flex-start;
  margin-top: 10px;
  touch-action: manipulation;
}

.ZNmiFA8U7s7XzmBlxvUI:hover:not(:disabled) {
  background: var(--dst-primary-strong);
}

.ZNmiFA8U7s7XzmBlxvUI:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ZNmiFA8U7s7XzmBlxvUI:focus-visible {
  outline: 3px solid rgba(32, 94, 200, 0.45);
  outline-offset: 2px;
}

._JIZa0Ayeo02WRohB1V_ {
  min-height: 34px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--dst-input-border);
  background: transparent;
  color: var(--dst-text);
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
}

._JIZa0Ayeo02WRohB1V_:hover:not(:disabled) {
  border-color: var(--dst-primary);
  color: var(--dst-primary);
}

._JIZa0Ayeo02WRohB1V_:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .zrnnKgqd8zVcwiV3Ohrh {
    padding: 12px;
  }

  .V_p_k342ekky0oYg_AxE {
    font-size: 1.3em;
    margin-bottom: 16px;
  }

  .TUgL9kYas9uFiVR_c4aY {
    max-width: 100%;
  }
}

.euaeUO0M8QwaLz7hva8a {
  display: grid;
  grid-template-columns: repeat(3, minmax(96px, 1fr));
  gap: 10px;
}

.MSWk8aOMHxaoEOuHCnt7 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.Ow3eHY_nat6RGyYlx9ho {
  font-size: 0.85em;
  font-weight: 700;
  color: var(--dst-text);
}

.aZaKWnk26d1YkYfUA0NF {
  width: 100%;
  box-sizing: border-box;
  min-height: 44px;
  padding: 8px 10px;
  border: 1px solid var(--dst-input-border);
  border-radius: 6px;
  font-size: 1em;
  font-family: inherit;
  color: var(--dst-text);
  background: var(--dst-input-bg);
  transition: border-color 0.14s, box-shadow 0.14s;
}

@media (max-width: 1024px) {
  ._9Wj9uBzlLRBxKFIsuQdA {
    grid-column: span 1;
    min-width: 0;
  }
}

.aZaKWnk26d1YkYfUA0NF:focus {
  outline: none;
  border-color: var(--dst-primary);
  box-shadow: 0 0 0 3px rgba(32, 94, 200, 0.15);
}

.aZaKWnk26d1YkYfUA0NF:disabled {
  background: var(--dst-input-disabled-bg);
  cursor: not-allowed;
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/components/OfficerDashboard/tabs/StatEntry.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;;;EAGE,aAAa;EACb,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;;;EAGE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".container {\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.title {\n  font-size: 1.5em;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: var(--dst-text);\n}\n\n.alert {\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  border-radius: 6px;\n  font-size: 1em;\n  border: 1px solid transparent;\n}\n\n.alert.error {\n  background: var(--dst-error-bg);\n  color: var(--dst-error-text);\n  border-color: var(--dst-error-border);\n}\n\n.alert.success {\n  background: var(--dst-success-bg);\n  color: var(--dst-success-text);\n  border-color: var(--dst-success-border);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n\n.categoryGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 14px;\n}\n\n.categoryItem {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mileageCategoryItem {\n  grid-column: span 2;\n  min-width: 320px;\n}\n\n.lockedBadge {\n  font-size: 0.75em;\n  color: var(--dst-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.categoryLabel {\n  font-weight: 600;\n  font-size: 0.9em;\n  color: var(--dst-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.abbr {\n  color: var(--dst-muted);\n  font-weight: 400;\n}\n\n.categoryInput {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 44px;\n  padding: 8px 10px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 6px;\n  font-size: 1em;\n  font-family: inherit;\n  color: var(--dst-text);\n  background: var(--dst-input-bg);\n  transition: border-color 0.14s, box-shadow 0.14s;\n}\n\n.categoryInput:focus {\n  outline: none;\n  border-color: var(--dst-primary);\n  box-shadow: 0 0 0 3px rgba(32, 94, 200, 0.15);\n}\n\n.categoryInput:disabled {\n  background: var(--dst-input-disabled-bg);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.empty {\n  color: var(--dst-muted);\n  font-size: 0.95em;\n  padding: 8px 0;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.label {\n  font-weight: 600;\n  font-size: 0.95em;\n  color: var(--dst-text);\n}\n\n.dateShortcuts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.dateShortcutButton {\n  min-height: 36px;\n  padding: 7px 14px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 6px;\n  background: var(--dst-input-bg);\n  color: var(--dst-text);\n  font-family: inherit;\n  font-size: 0.9em;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.13s, background 0.13s, color 0.13s;\n}\n\n.dateShortcutButton:hover:not(:disabled) {\n  border-color: var(--dst-primary);\n  color: var(--dst-primary);\n}\n\n.dateShortcutButtonActive {\n  border-color: var(--dst-primary);\n  background: var(--dst-primary);\n  color: white;\n}\n\n.dateShortcutButtonActive:hover:not(:disabled) {\n  color: white;\n}\n\n.dateShortcutButton:focus-visible {\n  outline: 3px solid rgba(32, 94, 200, 0.35);\n  outline-offset: 2px;\n}\n\n.dateShortcutButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.input,\n.select,\n.textarea {\n  min-height: 44px;\n  padding: 8px 10px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 6px;\n  font-size: 1em;\n  font-family: inherit;\n  color: var(--dst-text);\n  background: var(--dst-input-bg);\n  transition: border-color 0.14s, box-shadow 0.14s;\n}\n\n.input:focus,\n.select:focus,\n.textarea:focus {\n  outline: none;\n  border-color: var(--dst-primary);\n  box-shadow: 0 0 0 3px rgba(32, 94, 200, 0.15);\n}\n\n.input:disabled,\n.select:disabled,\n.textarea:disabled {\n  background: var(--dst-input-disabled-bg);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.textarea {\n  resize: vertical;\n  font-family: inherit;\n}\n\n.button {\n  min-height: 44px;\n  padding: 10px 20px;\n  font-size: 1em;\n  font-weight: 600;\n  background: var(--dst-primary);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.13s;\n  align-self: flex-start;\n  margin-top: 10px;\n  touch-action: manipulation;\n}\n\n.button:hover:not(:disabled) {\n  background: var(--dst-primary-strong);\n}\n\n.button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.button:focus-visible {\n  outline: 3px solid rgba(32, 94, 200, 0.45);\n  outline-offset: 2px;\n}\n\n.requestChangeButton {\n  min-height: 34px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--dst-input-border);\n  background: transparent;\n  color: var(--dst-text);\n  font-size: 0.85em;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.requestChangeButton:hover:not(:disabled) {\n  border-color: var(--dst-primary);\n  color: var(--dst-primary);\n}\n\n.requestChangeButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 12px;\n  }\n\n  .title {\n    font-size: 1.3em;\n    margin-bottom: 16px;\n  }\n\n  .form {\n    max-width: 100%;\n  }\n}\n\n.mileageGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(96px, 1fr));\n  gap: 10px;\n}\n\n.mileageField {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.mileageLabel {\n  font-size: 0.85em;\n  font-weight: 700;\n  color: var(--dst-text);\n}\n\n.mileageInput {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 44px;\n  padding: 8px 10px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 6px;\n  font-size: 1em;\n  font-family: inherit;\n  color: var(--dst-text);\n  background: var(--dst-input-bg);\n  transition: border-color 0.14s, box-shadow 0.14s;\n}\n\n@media (max-width: 1024px) {\n  .mileageCategoryItem {\n    grid-column: span 1;\n    min-width: 0;\n  }\n}\n\n.mileageInput:focus {\n  outline: none;\n  border-color: var(--dst-primary);\n  box-shadow: 0 0 0 3px rgba(32, 94, 200, 0.15);\n}\n\n.mileageInput:disabled {\n  background: var(--dst-input-disabled-bg);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zrnnKgqd8zVcwiV3Ohrh`,
	"title": `V_p_k342ekky0oYg_AxE`,
	"alert": `cEsCc6UFyhYVH1RRPySP`,
	"error": `cdYHpdIYqZcEUSkX_viA`,
	"success": `DJHreniN47YWIu3ySOvF`,
	"form": `TUgL9kYas9uFiVR_c4aY`,
	"categoryGrid": `hvZVl0xvldSltremtLE2`,
	"categoryItem": `I3WnSXs8T_B84eevGhBM`,
	"mileageCategoryItem": `_9Wj9uBzlLRBxKFIsuQdA`,
	"lockedBadge": `iM4q_MtVyEuCTjhXzOAi`,
	"categoryLabel": `B3V4tzkUVM5zdHYWqqv7`,
	"abbr": `JtA8ditqklrcVJRzwiOt`,
	"categoryInput": `KlgQNmlH6zpNi0FMmk88`,
	"empty": `a8Wn6KbrBaFrF6dFNCbA`,
	"formGroup": `ihjTVP2TpeFXtTc0qi_T`,
	"label": `bdfelXso0RVveyjTtjKf`,
	"dateShortcuts": `ZdA9vPCjHgN321OY69PN`,
	"dateShortcutButton": `HJ0iYyxjsuXbkZgMhf8T`,
	"dateShortcutButtonActive": `yMLh0cUgL0lmJjspp1GM`,
	"input": `dtW4oELHD4VZ9JObjRq_`,
	"select": `mN_GiZS1INZxWaUbIifg`,
	"textarea": `kqUqvWv8oL_OJOB8GE7W`,
	"button": `ZNmiFA8U7s7XzmBlxvUI`,
	"requestChangeButton": `_JIZa0Ayeo02WRohB1V_`,
	"mileageGrid": `euaeUO0M8QwaLz7hva8a`,
	"mileageField": `MSWk8aOMHxaoEOuHCnt7`,
	"mileageLabel": `Ow3eHY_nat6RGyYlx9ho`,
	"mileageInput": `aZaKWnk26d1YkYfUA0NF`
};
export default ___CSS_LOADER_EXPORT___;
